import { createI18n } from 'vue-i18n';
import en from './i18n/locales/en.json';
import sq from './i18n/locales/sq.json';
import tr from './i18n/locales/tr.json';
import ar from './i18n/locales/ar.json';
import me from './i18n/locales/me.json';

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: localStorage.getItem('pagaime_lang') || 'sq',
  fallbackLocale: 'sq',
  messages: {
    en,
    sq,
    tr,
    ar,
    me
  }
});

export default i18n;

